import $ from 'jquery';

const modalTemplate = `
<div class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header p-0">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body"></div>
        </div>
    </div>
</div>`;

(function () {
    $(document).on('show.bs.modal', function (e) {
        // Circumvent z-index issues
        $(e.target).appendTo('body');
    }).on('click', 'a.open-modal', function (e) {
        // Open modal windows when clicking on <a href="#..." class="open-modal">
        e.preventDefault();
        $($(this).attr('href')).modal('show');
    }).on('click', 'a.inline', function (e) {
        if ($.fn.fancybox) {
            return;
        }
        // Polyfill to replace fancybox modal windows with Bootstrap modal windows
        const me = this;
        e.preventDefault();
        fancyboxToBootstrapModal(this, function (modal) {
            let fancyPanel = $($(me).attr('href'));
            let content = fancyPanel.contents().clone();
            modal.find('.modal-body').append(content);

            // Apply modal-sm, modal-lg or modal-xl to the modal window if applied as a class to the fancybox panel
            let match = fancyPanel.attr('class').match(/(^|\s)modal-(sm|md|lg|xl)(\s|$)/);
            if (match) {
                modal.find('.modal-dialog').removeClass('modal-xl').addClass(match[0]);
            }
        });
    }).on('click', 'a.youtube-video, a.testimonial-video, a.modal-video', function (e) {
        const me = this;
        e.preventDefault();
        fancyboxToBootstrapModal(this, function (modal) {
            let content = $('<div class="embed-responsive embed-responsive-16by9"><iframe class="embed-responsive-item" src="" allow="autoplay"></iframe>');
            content.find('iframe').attr('src', $(me).attr('href'));
            modal.find('.modal-body').addClass('p-0').append(content);
        });
    });

    // Add a DOM ready event listener to open modal windows automatically based on the hash in the url
    $(function () {
        let hash = (window.location.hash).toString().replace(/^#/, '');
        if (hash && $('#'+hash+'.modal').length) {
            $('#'+hash+'.modal').modal('show');
        }
    });
})();

function fancyboxToBootstrapModal(a, func)
{
    let modal = $(modalTemplate);
    func && func(modal);

    modal.on('hidden.bs.modal', function (e) {
            modal.remove();
        })
        .appendTo('body')
        .modal('show');
}

/**
 * Automatically show modal windows that have an attribute data-auto-show="true" set
 */
export function autoShowModals (context) {
    $('.modal[data-auto-show]', context || document).modal('show');
}

export default {autoShowModals};